import { defineComponent, ref, watch, openBlock, createElementBlock, normalizeClass } from "vue";
const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const EQ_CHAR = "=".charCodeAt(0);
const lookup = new Uint8Array(256);
for (let i = 0; i < CHARS.length; i++) {
  lookup[CHARS.charCodeAt(i)] = i;
}
function encode(bytes) {
  const len = bytes.length;
  let base64 = "";
  for (let i = 0; i < len; i += 3) {
    const b0 = bytes[i + 0];
    const b1 = bytes[i + 1];
    const b2 = bytes[i + 2];
    base64 += CHARS.charAt(b0 >>> 2);
    base64 += CHARS.charAt((b0 & 3) << 4 | b1 >>> 4);
    base64 += CHARS.charAt((b1 & 15) << 2 | b2 >>> 6);
    base64 += CHARS.charAt(b2 & 63);
  }
  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1) + "=";
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + "==";
  }
  return base64;
}
function decode(base64) {
  const len = base64.length;
  let bufferLength = len * 3 >>> 2;
  if (base64.charCodeAt(len - 1) === EQ_CHAR)
    bufferLength--;
  if (base64.charCodeAt(len - 2) === EQ_CHAR)
    bufferLength--;
  const bytes = new Uint8Array(bufferLength);
  for (let i = 0, p = 0; i < len; i += 4) {
    const encoded1 = lookup[base64.charCodeAt(i + 0)];
    const encoded2 = lookup[base64.charCodeAt(i + 1)];
    const encoded3 = lookup[base64.charCodeAt(i + 2)];
    const encoded4 = lookup[base64.charCodeAt(i + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }
  return bytes;
}
var css = ".frc-captcha *{margin:0;padding:0;border:0;text-align:initial;border-radius:px;filter:none!important;transition:none!important;font-weight:400;font-size:14px;line-height:1.2;text-decoration:none;background-color:initial;color:#222}.frc-captcha{position:relative;width:312px;border:1px solid #f4f4f4;padding-bottom:12px;background-color:#fff}.frc-captcha b{font-weight:700}.frc-container{display:flex;align-items:center;min-height:52px}.frc-icon{fill:#222;stroke:#222;flex-shrink:0;margin:8px 8px 0}.frc-icon.frc-warning{fill:#c00}.frc-success .frc-icon{animation:1s ease-in both frc-fade-in}.frc-content{white-space:nowrap;display:flex;flex-direction:column;margin:4px 6px 0 0;overflow-x:auto;flex-grow:1}.frc-banner{position:absolute;bottom:0;right:6px;line-height:1}.frc-banner *{font-size:10px;opacity:.8;text-decoration:none}.frc-progress{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:3px 0;height:4px;border:none;background-color:#eee;color:#222;width:100%;transition:.5s linear}.frc-progress::-webkit-progress-bar{background:#eee}.frc-progress::-webkit-progress-value{background:#222}.frc-progress::-moz-progress-bar{background:#222}.frc-button{cursor:pointer;padding:2px 6px;background-color:#f1f1f1;border:1px solid transparent;text-align:center;font-weight:600;text-transform:none}.frc-button:focus{border:1px solid #333}.frc-button:hover{background-color:#ddd}.frc-captcha-solution{display:none}.frc-err-url{text-decoration:underline;font-size:.9em}.dark.frc-captcha{color:#fff;background-color:#222;border-color:#333}.dark.frc-captcha *{color:#fff}.dark.frc-captcha button{background-color:#444}.dark .frc-icon{fill:#fff;stroke:#fff}.dark .frc-progress{background-color:#444}.dark .frc-progress::-webkit-progress-bar{background:#444}.dark .frc-progress::-webkit-progress-value{background:#ddd}.dark .frc-progress::-moz-progress-bar{background:#ddd}@keyframes frc-fade-in{from{opacity:0}to{opacity:1}}";
const SOLVER_TYPE_JS = 1;
const CHALLENGE_SIZE_BYTES = 128;
const loaderSVG = `<circle cx="12" cy="12" r="8" stroke-width="3" stroke-dasharray="15 10" fill="none" stroke-linecap="round" transform="rotate(0 12 12)"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.9s" values="0 12 12;360 12 12"/></circle>`;
const errorSVG = `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>`;
function getTemplate(fieldName, svgContent, textContent, solutionString, buttonText, progress = false, debugData, additionalContainerClasses) {
  return `<div class="frc-container${additionalContainerClasses ? " " + additionalContainerClasses : ""}">
<svg class="frc-icon" role="img" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 24 24">${svgContent}</svg>
<div class="frc-content">
    <span class="frc-text" ${debugData ? `title="${debugData}"` : ``}>${textContent}</span>
    ${buttonText ? `<button type="button" class="frc-button">${buttonText}</button>` : ""}
    ${progress ? `<progress class="frc-progress" value="0">0%</progress>` : ""}
</div>
</div><span class="frc-banner"><a href="https://friendlycaptcha.com/" rel="noopener" target="_blank"><b>Friendly</b>Captcha \u21D7</a></span>
<input name="${fieldName}" class="frc-captcha-solution" type="hidden" value="${solutionString}">`;
}
function getReadyHTML(fieldName, l) {
  return getTemplate(fieldName, `<path d="M17,11c0.34,0,0.67,0.04,1,0.09V6.27L10.5,3L3,6.27v4.91c0,4.54,3.2,8.79,7.5,9.82c0.55-0.13,1.08-0.32,1.6-0.55 C11.41,19.47,11,18.28,11,17C11,13.69,13.69,11,17,11z"/><path d="M17,13c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4s4-1.79,4-4C21,14.79,19.21,13,17,13z M17,14.38"/>`, l.text_ready, ".UNSTARTED", l.button_start, false);
}
function getFetchingHTML(fieldName, l) {
  return getTemplate(fieldName, loaderSVG, l.text_fetching, ".FETCHING", void 0, true);
}
function getRunningHTML(fieldName, l) {
  return getTemplate(fieldName, loaderSVG, l.text_solving, ".UNFINISHED", void 0, true);
}
function getDoneHTML(fieldName, l, solution, data) {
  const timeData = `Completed: ${data.t.toFixed(0)}s (${(data.h / data.t * 1e-3).toFixed(0)}K/s)${data.solver === SOLVER_TYPE_JS ? " JS Fallback" : ""}`;
  return getTemplate(fieldName, `<title>${timeData}</title><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"></path>`, l.text_completed, solution, void 0, false, timeData, "frc-success");
}
function getExpiredHTML(fieldName, l) {
  return getTemplate(fieldName, errorSVG, l.text_expired, ".EXPIRED", l.button_restart);
}
function getErrorHTML(fieldName, l, errorDescription, recoverable = true, headless = false) {
  return getTemplate(fieldName, errorSVG, `<b>${l.text_error}</b><br>${errorDescription}`, headless ? ".HEADLESS_ERROR" : ".ERROR", recoverable ? l.button_retry : void 0);
}
function injectStyle() {
  if (!document.querySelector("#frc-style")) {
    const styleSheet = document.createElement("style");
    styleSheet.id = "frc-style";
    styleSheet.innerHTML = css;
    document.head.appendChild(styleSheet);
  }
}
function updateProgressBar(element, data) {
  const p = element.querySelector(".frc-progress");
  const perc = (data.i + 1) / data.n;
  if (p) {
    p.value = perc;
    p.innerText = perc.toFixed(2) + "%";
    p.title = data.i + 1 + "/" + data.n + " (" + (data.h / data.t * 1e-3).toFixed(0) + "K/s)";
  }
}
function findParentFormElement(element) {
  while (element.tagName !== "FORM") {
    element = element.parentElement;
    if (!element) {
      return null;
    }
  }
  return element;
}
function executeOnceOnFocusInEvent(element, listener) {
  element.addEventListener("focusin", listener, { once: true, passive: true });
}
let nav;
let ua;
if (typeof navigator !== "undefined") {
  nav = navigator;
  ua = nav.userAgent.toLowerCase();
}
function isHeadless() {
  let correctPrototypes = true;
  try {
    correctPrototypes = PluginArray.prototype === nav.plugins.__proto__;
    if (nav.plugins.length > 0) {
      correctPrototypes = correctPrototypes && Plugin.prototype === nav.plugins[0].__proto__;
    }
  } catch (e) {
  }
  return ua.indexOf("headless") !== -1 || nav.appVersion.indexOf("Headless") !== -1 || ua.indexOf("bot") !== -1 || ua.indexOf("crawl") !== -1 || nav.webdriver === true || !nav.language || nav.languages !== void 0 && !nav.languages.length || !correctPrototypes;
}
function difficultyToThreshold(value) {
  if (value > 255) {
    value = 255;
  } else if (value < 0) {
    value = 0;
  }
  return Math.pow(2, (255.999 - value) / 8) >>> 0;
}
const PUZZLE_EXPIRY_OFFSET = 13;
const NUMBER_OF_PUZZLES_OFFSET = 14;
const PUZZLE_DIFFICULTY_OFFSET = 15;
function getPuzzleSolverInputs(puzzleBuffer, numPuzzles) {
  const startingPoints = [];
  for (let i = 0; i < numPuzzles; i++) {
    const input = new Uint8Array(CHALLENGE_SIZE_BYTES);
    input.set(puzzleBuffer);
    input[120] = i;
    startingPoints.push(input);
  }
  return startingPoints;
}
function decodeBase64Puzzle(base64Puzzle) {
  const parts = base64Puzzle.split(".");
  const puzzle = parts[1];
  const arr = decode(puzzle);
  return {
    signature: parts[0],
    base64: puzzle,
    buffer: arr,
    n: arr[NUMBER_OF_PUZZLES_OFFSET],
    threshold: difficultyToThreshold(arr[PUZZLE_DIFFICULTY_OFFSET]),
    expiry: arr[PUZZLE_EXPIRY_OFFSET] * 3e5
  };
}
async function getPuzzle(urlsSeparatedByComma, siteKey, lang) {
  const urls = urlsSeparatedByComma.split(",");
  for (let i = 0; i < urls.length; i++) {
    try {
      const response = await fetchAndRetryWithBackoff(urls[i] + "?sitekey=" + siteKey, { headers: [["x-frc-client", "js-0.9.0"]], mode: "cors" }, 2);
      if (response.ok) {
        const json = await response.json();
        return json.data.puzzle;
      } else {
        let json;
        try {
          json = await response.json();
        } catch (e) {
        }
        if (json && json.errors && json.errors[0] === "endpoint_not_enabled") {
          throw Error(`Endpoint not allowed (${response.status})`);
        }
        if (i === urls.length - 1) {
          throw Error(`Response status ${response.status} ${response.statusText}`);
        }
      }
    } catch (e) {
      console.error("[FriendlyCaptcha]:", e);
      throw Error(`${lang.text_fetch_error} <a class="frc-err-url" href="${urls[i]}">${urls[i]}</a>`);
    }
  }
  throw Error(`Internal error`);
}
async function fetchAndRetryWithBackoff(url, opts, n) {
  let time = 1e3;
  return fetch(url, opts).catch(async (error) => {
    if (n === 0)
      throw error;
    await new Promise((r) => setTimeout(r, time));
    time *= 4;
    return fetchAndRetryWithBackoff(url, opts, n - 1);
  });
}
const LANG_EN = {
  text_init: "Initializing..",
  text_ready: "Anti-Robot Verification",
  button_start: "Click to start verification",
  text_fetching: "Fetching Challenge",
  text_solving: "Verifying you are human..",
  text_completed: "I am human",
  text_expired: "Anti-Robot verification expired",
  button_restart: "Restart",
  text_error: "Verification failed",
  button_retry: "Retry",
  text_fetch_error: "Failed to connect to"
};
const LANG_FR = {
  text_init: "Chargement..",
  text_ready: "Verification Anti-Robot",
  button_start: "Cliquez ici pour v\xE9rifier",
  text_fetching: "Chargement du challenge",
  text_solving: "V\xE9rification que vous \xEAtes humain..",
  text_completed: "Je suis humain",
  text_expired: "Verification \xE9chue",
  button_restart: "Recommencer",
  text_error: "Echec de verification",
  button_retry: "Recommencer",
  text_fetch_error: "Probl\xE8me de connexion avec"
};
const LANG_DE = {
  text_init: "Initialisierung..",
  text_ready: "Anti-Roboter-Verifizierung",
  button_start: "Hier klicken",
  text_fetching: "Herausforderung laden..",
  text_solving: "Verifizierung, dass Sie ein Mensch sind..",
  text_completed: "Ich bin ein Mensch",
  text_expired: "Verifizierung abgelaufen",
  button_restart: "Erneut starten",
  text_error: "Verifizierung fehlgeschlagen",
  button_retry: "Erneut versuchen",
  text_fetch_error: "Verbindungsproblem mit"
};
const LANG_NL = {
  text_init: "Initializeren..",
  text_ready: "Anti-robotverificatie",
  button_start: "Klik om te starten",
  text_fetching: "Aan het laden..",
  text_solving: "Anti-robotverificatie bezig..",
  text_completed: "Ik ben een mens",
  text_expired: "Verificatie verlopen",
  button_restart: "Opnieuw starten",
  text_error: "Verificatie mislukt",
  button_retry: "Opnieuw proberen",
  text_fetch_error: "Verbinding mislukt met"
};
const LANG_IT = {
  text_init: "Inizializzazione...",
  text_ready: "Verifica Anti-Robot",
  button_start: "Clicca per iniziare",
  text_fetching: "Caricamento...",
  text_solving: "Verificando che sei umano...",
  text_completed: "Non sono un robot",
  text_expired: "Verifica Anti-Robot scaduta",
  button_restart: "Ricomincia",
  text_error: "Verifica fallita",
  button_retry: "Riprova",
  text_fetch_error: "Problema di connessione con"
};
const LANG_PT = {
  text_init: "Inicializando..",
  text_ready: "Verifica\xE7\xE3o Anti-Rob\xF4",
  button_start: "Clique para iniciar verifica\xE7\xE3o",
  text_fetching: "Carregando..",
  text_solving: "Verificando se voc\xEA \xE9 humano..",
  text_completed: "Eu sou humano",
  text_expired: "Verifica\xE7\xE3o Anti-Rob\xF4 expirada",
  button_restart: "Reiniciar",
  text_error: "Verifica\xE7\xE3o falhou",
  button_retry: "Tentar novamente",
  text_fetch_error: "Falha de conex\xE3o com"
};
const LANG_ES = {
  text_init: "Inicializando..",
  text_ready: "Verificaci\xF3n Anti-Robot",
  button_start: "Haga clic para iniciar la verificaci\xF3n",
  text_fetching: "Cargando desaf\xEDo",
  text_solving: "Verificando que eres humano..",
  text_completed: "Soy humano",
  text_expired: "Verificaci\xF3n Anti-Robot expirada",
  button_restart: "Reiniciar",
  text_error: "Ha fallado la verificaci\xF3n",
  button_retry: "Intentar de nuevo",
  text_fetch_error: "Error al conectarse a"
};
const LANG_CA = {
  text_init: "Inicialitzant...",
  text_ready: "Verificaci\xF3 Anti-Robot",
  button_start: "Fes clic per comen\xE7ar la verificaci\xF3",
  text_fetching: "Carregant repte",
  text_solving: "Verificant que ets hum\xE0..",
  text_completed: "Soc hum\xE0",
  text_expired: "La verificaci\xF3 Anti-Robot ha expirat",
  button_restart: "Reiniciar",
  text_error: "Ha fallat la verificaci\xF3",
  button_retry: "Tornar a provar",
  text_fetch_error: "Error connectant a"
};
const LANG_JA = {
  text_init: "\u958B\u59CB\u3057\u3066\u3044\u307E\u3059...",
  text_ready: "\u30A2\u30F3\u30C1\u30ED\u30DC\u30C3\u30C8\u8A8D\u8A3C",
  button_start: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u8A8D\u8A3C\u3092\u958B\u59CB",
  text_fetching: "\u30ED\u30FC\u30C9\u3057\u3066\u3044\u307E\u3059",
  text_solving: "\u8A8D\u8A3C\u4E2D...",
  text_completed: "\u79C1\u306F\u30ED\u30DC\u30C3\u30C8\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
  text_expired: "\u8A8D\u8A3C\u306E\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059",
  button_restart: "\u518D\u5EA6\u8A8D\u8A3C\u3092\u884C\u3046",
  text_error: "\u8A8D\u8A3C\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
  button_retry: "\u518D\u5EA6\u8A8D\u8A3C\u3092\u884C\u3046",
  text_fetch_error: "\u63A5\u7D9A\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F"
};
const LANG_DA = {
  text_init: "Initialiserer..",
  text_ready: "Anti-robot verifikation",
  button_start: "Klik for at starte verifikationen",
  text_fetching: "Henter udfordring",
  text_solving: "Bekr\xE6fter, at du er menneske..",
  text_completed: "Jeg er menneske",
  text_expired: "Anti-Robot-verifikation er udl\xF8bet",
  button_restart: "Genstart",
  text_error: "Bekr\xE6ftelse mislykkedes",
  button_retry: "Pr\xF8v igen",
  text_fetch_error: "Det lykkedes ikke at oprette forbindelse til"
};
const localizations = {
  en: LANG_EN,
  de: LANG_DE,
  nl: LANG_NL,
  fr: LANG_FR,
  it: LANG_IT,
  pt: LANG_PT,
  es: LANG_ES,
  ca: LANG_CA,
  ja: LANG_JA,
  da: LANG_DA
};
function createDiagnosticsBuffer(solverID, timeToSolved) {
  const arr = new Uint8Array(3);
  const view = new DataView(arr.buffer);
  view.setUint8(0, solverID);
  view.setUint16(1, timeToSolved);
  return arr;
}
var workerString = '!function(){"use strict";const A="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",I="=".charCodeAt(0),g=new Uint8Array(256);for(let I=0;I<A.length;I++)g[A.charCodeAt(I)]=I;function C(A){const I={},g=A.exports,C=g.memory,t=g.__alloc,B=g.__retain,Q=g.__rtti_base||-1;return I.__allocArray=(A,I)=>{const g=function(A){return new Uint32Array(C.buffer)[(Q+4>>>2)+2*A]}(A),e=31-Math.clz32(g>>>6&31),r=I.length,i=t(r<<e,0),o=t(12,A),n=new Uint32Array(C.buffer);n[o+0>>>2]=B(i),n[o+4>>>2]=i,n[o+8>>>2]=r<<e;const E=C.buffer,s=new Uint8Array(E);if(16384&g)for(let A=0;A<r;++A)s[(i>>>e)+A]=B(I[A]);else s.set(I,i>>>e);return o},I.__getUint8Array=A=>{const I=new Uint32Array(C.buffer),g=I[A+4>>>2];return new Uint8Array(C.buffer,g,I[g-4>>>2]>>>0)},function(A,I={}){const g=A.__argumentsLength?I=>{A.__argumentsLength.value=I}:A.__setArgumentsLength||A.__setargc||(()=>({}));for(const C in A){if(!Object.prototype.hasOwnProperty.call(A,C))continue;const t=A[C],B=C.split(".")[0];"function"==typeof t&&t!==g?(I[B]=(...A)=>(g(A.length),t(...A))).original=t:I[B]=t}return I}(g,I)}class t{constructor(A){this.b=new Uint8Array(128),this.h=new Uint32Array(16),this.t=0,this.c=0,this.v=new Uint32Array(32),this.m=new Uint32Array(32),this.outlen=A}}function B(A,I){return A[I]^A[I+1]<<8^A[I+2]<<16^A[I+3]<<24}function Q(A,I,g,C,t,B,Q,e){const r=I[Q],i=I[Q+1],o=I[e],n=I[e+1];let E,s,w,a,c=A[g],D=A[g+1],f=A[C],h=A[C+1],l=A[t],y=A[t+1],U=A[B],M=A[B+1];E=c+f,s=(c&f|(c|f)&~E)>>>31,c=E,D=D+h+s,E=c+r,s=(c&r|(c|r)&~E)>>>31,c=E,D=D+i+s,w=U^c,a=M^D,U=a,M=w,E=l+U,s=(l&U|(l|U)&~E)>>>31,l=E,y=y+M+s,w=f^l,a=h^y,f=w>>>24^a<<8,h=a>>>24^w<<8,E=c+f,s=(c&f|(c|f)&~E)>>>31,c=E,D=D+h+s,E=c+o,s=(c&o|(c|o)&~E)>>>31,c=E,D=D+n+s,w=U^c,a=M^D,U=w>>>16^a<<16,M=a>>>16^w<<16,E=l+U,s=(l&U|(l|U)&~E)>>>31,l=E,y=y+M+s,w=f^l,a=h^y,f=a>>>31^w<<1,h=w>>>31^a<<1,A[g]=c,A[g+1]=D,A[C]=f,A[C+1]=h,A[t]=l,A[t+1]=y,A[B]=U,A[B+1]=M}const e=[4089235720,1779033703,2227873595,3144134277,4271175723,1013904242,1595750129,2773480762,2917565137,1359893119,725511199,2600822924,4215389547,528734635,327033209,1541459225],r=[0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,28,20,8,16,18,30,26,12,2,24,0,4,22,14,10,6,22,16,24,0,10,4,30,26,20,28,6,12,14,2,18,8,14,18,6,2,26,24,22,28,4,12,10,20,8,0,30,16,18,0,10,14,4,8,20,30,28,2,22,24,12,16,6,26,4,24,12,20,0,22,16,6,8,26,14,10,30,28,2,18,24,10,2,30,28,26,8,20,0,14,12,6,18,4,16,22,26,22,14,28,24,2,6,18,10,0,30,8,16,12,4,20,12,30,28,18,22,6,0,16,24,4,26,14,2,8,20,10,20,4,16,8,14,12,2,10,30,22,18,28,6,24,26,0,0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,28,20,8,16,18,30,26,12,2,24,0,4,22,14,10,6];function i(A,I){const g=A.v,C=A.m;for(let I=0;I<16;I++)g[I]=A.h[I],g[I+16]=e[I];g[24]=g[24]^A.t,g[25]=g[25]^A.t/4294967296,I&&(g[28]=~g[28],g[29]=~g[29]);for(let I=0;I<32;I++)C[I]=B(A.b,4*I);for(let A=0;A<12;A++)Q(g,C,0,8,16,24,r[16*A+0],r[16*A+1]),Q(g,C,2,10,18,26,r[16*A+2],r[16*A+3]),Q(g,C,4,12,20,28,r[16*A+4],r[16*A+5]),Q(g,C,6,14,22,30,r[16*A+6],r[16*A+7]),Q(g,C,0,10,20,30,r[16*A+8],r[16*A+9]),Q(g,C,2,12,22,24,r[16*A+10],r[16*A+11]),Q(g,C,4,14,16,26,r[16*A+12],r[16*A+13]),Q(g,C,6,8,18,28,r[16*A+14],r[16*A+15]);for(let I=0;I<16;I++)A.h[I]=A.h[I]^g[I]^g[I+16]}function o(A,I){for(let I=0;I<16;I++)A.h[I]=e[I];A.b.set(I),A.h[0]^=16842752^A.outlen}async function n(){return(A,I,g=4294967295)=>[A,function(A,I,g){if(128!=A.length)throw Error("Invalid input");const C=A.buffer,B=new DataView(C),Q=new t(32);Q.t=128;const e=B.getUint32(124,!0),r=e+g;for(let g=e;g<r;g++)if(B.setUint32(124,g,!0),o(Q,A),i(Q,!0),Q.h[0]<I)return 0==ASC_TARGET?new Uint8Array(Q.h.buffer):Uint8Array.wrap(Q.h.buffer);return new Uint8Array(0)}(A,I,g)]}let E,s;Uint8Array.prototype.slice||Object.defineProperty(Uint8Array.prototype,"slice",{value:function(A,I){return new Uint8Array(Array.prototype.slice.call(this,A,I))}}),self.ASC_TARGET=0;const w=new Promise((A=>s=A));let a=!1;self.onerror=A=>{self.postMessage({type:"error",message:JSON.stringify(A)})},self.onmessage=async A=>{const t=A.data;try{if("solver"===t.type){if(t.forceJS){E=1;const A=await n();s(A)}else try{E=2;const A=WebAssembly.compile(function(A){const C=A.length;let t=3*C>>>2;A.charCodeAt(C-1)===I&&t--,A.charCodeAt(C-2)===I&&t--;const B=new Uint8Array(t);for(let I=0,t=0;I<C;I+=4){const C=g[A.charCodeAt(I+0)],Q=g[A.charCodeAt(I+1)],e=g[A.charCodeAt(I+2)],r=g[A.charCodeAt(I+3)];B[t++]=C<<2|Q>>4,B[t++]=(15&Q)<<4|e>>2,B[t++]=(3&e)<<6|63&r}return B}("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")),t=await async function(A){const I=await async function(A){const I={env:{abort(){throw Error("Wasm aborted")}}};return{exports:C(await WebAssembly.instantiate(A,I))}}(A),g=I.exports.__retain(I.exports.__allocArray(I.exports.Uint8Array_ID,new Uint8Array(128)));let t=I.exports.__getUint8Array(g);return(A,C,B=4294967295)=>{t.set(A);const Q=I.exports.solveBlake2b(g,C,B);t=I.exports.__getUint8Array(g);const e=I.exports.__getUint8Array(Q);return I.exports.__release(Q),[t,e]}}(await A);s(t)}catch(A){console.log("FriendlyCaptcha failed to initialize WebAssembly, falling back to Javascript solver: "+A.toString()),E=1;const I=await n();s(I)}self.postMessage({type:"ready",solver:E})}else if("start"===t.type){if(a)return;a=!0;const A=await w;self.postMessage({type:"started"});let I=0;const g=t.puzzleSolverInputs,C=new Uint8Array(8*t.n);for(let B=t.startIndex;B<g.length;B+=t.numWorkers){let Q;for(let C=0;C<256;C++){g[B][123]=C;const[e,r]=A(g[B],t.threshold);if(0!==r.length){Q=e;break}console.warn("FC: Internal error or no solution found"),I+=Math.pow(2,32)-1}const e=new DataView(Q.slice(-4).buffer).getUint32(0,!0);I+=e,C.set(Q.slice(-8),8*B),self.postMessage({type:"progress",h:e})}const B={type:"done",solution:C,totalH:I,startIndex:t.startIndex};self.postMessage(B)}}catch(A){setTimeout((()=>{throw A}))}}}();';
let URL;
if (typeof window !== "undefined") {
  URL = window.URL || window.webkitURL;
}
class WorkerGroup {
  constructor() {
    this.workers = [];
    this.numPuzzles = 0;
    this.startTime = 0;
    this.progress = 0;
    this.totalHashes = 0;
    this.puzzleSolverInputs = [];
    this.solutionBuffer = new Uint8Array(0);
    this.solverType = 1;
    this.readyCount = 0;
    this.startCount = 0;
    this.doneCount = 0;
    this.progressCallback = () => 0;
    this.readyCallback = () => 0;
    this.startedCallback = () => 0;
    this.doneCallback = () => 0;
    this.errorCallback = () => 0;
  }
  init() {
    if (this.workers.length > 0) {
      for (let i = 0; i < this.workers.length; i++) {
        this.workers[i].terminate();
      }
    }
    this.progress = 0;
    this.totalHashes = 0;
    this.readyCount = 0;
    this.startCount = 0;
    this.doneCount = 0;
    this.workers = new Array(4);
    const workerBlob = new Blob([workerString], { type: "text/javascript" });
    for (let i = 0; i < this.workers.length; i++) {
      this.workers[i] = new Worker(URL.createObjectURL(workerBlob));
      this.workers[i].onerror = (e) => this.errorCallback(e);
      this.workers[i].onmessage = (e) => {
        const data = e.data;
        if (!data)
          return;
        if (data.type === "progress") {
          this.progress++;
          this.totalHashes += data.h;
          this.progressCallback({
            n: this.numPuzzles,
            h: this.totalHashes,
            t: (Date.now() - this.startTime) / 1e3,
            i: this.progress
          });
        } else if (data.type === "ready") {
          this.readyCount++;
          this.solverType = data.solver;
          if (this.readyCount == this.workers.length) {
            this.readyCallback();
          }
        } else if (data.type === "started") {
          this.startCount++;
          if (this.startCount == 1) {
            this.startTime = Date.now();
            this.startedCallback();
          }
        } else if (data.type === "done") {
          this.doneCount++;
          for (let i2 = data.startIndex; i2 < this.puzzleSolverInputs.length; i2 += this.workers.length) {
            this.solutionBuffer.set(data.solution.subarray(i2 * 8, i2 * 8 + 8), i2 * 8);
          }
          if (this.doneCount == this.workers.length) {
            const totalTime = (Date.now() - this.startTime) / 1e3;
            this.doneCallback({
              solution: this.solutionBuffer,
              h: this.totalHashes,
              t: totalTime,
              diagnostics: createDiagnosticsBuffer(this.solverType, totalTime),
              solver: this.solverType
            });
          }
        } else if (data.type === "error") {
          this.errorCallback(data);
        }
      };
    }
  }
  setupSolver(forceJS = false) {
    const msg = { type: "solver", forceJS };
    for (let i = 0; i < this.workers.length; i++) {
      this.workers[i].postMessage(msg);
    }
  }
  start(puzzle) {
    this.puzzleSolverInputs = getPuzzleSolverInputs(puzzle.buffer, puzzle.n);
    this.solutionBuffer = new Uint8Array(8 * puzzle.n);
    this.numPuzzles = puzzle.n;
    for (let i = 0; i < this.workers.length; i++) {
      this.workers[i].postMessage({
        type: "start",
        puzzleSolverInputs: this.puzzleSolverInputs,
        threshold: puzzle.threshold,
        n: puzzle.n,
        numWorkers: this.workers.length,
        startIndex: i
      });
    }
  }
  terminateWorkers() {
    if (this.workers.length == 0)
      return;
    for (let i = 0; i < this.workers.length; i++) {
      this.workers[i].terminate();
    }
    this.workers = [];
  }
}
const PUZZLE_ENDPOINT_URL = "https://api.friendlycaptcha.com/api/v1/puzzle";
class WidgetInstance {
  constructor(element, options = {}) {
    this.workerGroup = new WorkerGroup();
    this.valid = false;
    this.needsReInit = false;
    this.hasBeenStarted = false;
    this.hasBeenDestroyed = false;
    this.opts = Object.assign({
      forceJSFallback: false,
      startMode: "focus",
      puzzleEndpoint: element.dataset["puzzleEndpoint"] || PUZZLE_ENDPOINT_URL,
      startedCallback: () => 0,
      readyCallback: () => 0,
      doneCallback: () => 0,
      errorCallback: () => 0,
      sitekey: element.dataset["sitekey"] || "",
      language: element.dataset["lang"] || "en",
      solutionFieldName: element.dataset["solutionFieldName"] || "frc-captcha-solution"
    }, options);
    this.e = element;
    if (typeof this.opts.language === "string") {
      let l = localizations[this.opts.language.toLowerCase()];
      if (l === void 0) {
        console.error('FriendlyCaptcha: language "' + this.opts.language + '" not found.');
        l = localizations.en;
      }
      this.lang = l;
    } else {
      this.lang = Object.assign(Object.assign({}, localizations.en), this.opts.language);
    }
    element.innerText = this.lang.text_init;
    injectStyle();
    this.init(this.opts.startMode === "auto" || this.e.dataset["start"] === "auto");
  }
  init(forceStart) {
    if (this.hasBeenDestroyed) {
      console.error("FriendlyCaptcha widget has been destroyed using destroy(), it can not be used anymore.");
      return;
    }
    this.initWorkerGroup();
    if (forceStart) {
      this.start();
    } else if (this.e.dataset["start"] !== "none" && (this.opts.startMode === "focus" || this.e.dataset["start"] === "focus")) {
      const form = findParentFormElement(this.e);
      if (form) {
        executeOnceOnFocusInEvent(form, () => {
          if (!this.hasBeenStarted) {
            this.start();
          }
        });
      } else {
        console.log("FriendlyCaptcha div seems not to be contained in a form, autostart will not work");
      }
    }
  }
  makeButtonStart() {
    const b = this.e.querySelector("button");
    if (b) {
      b.addEventListener("click", (e) => this.start(), { once: true, passive: true });
      b.addEventListener("touchstart", (e) => this.start(), { once: true, passive: true });
    }
  }
  onWorkerError(e) {
    this.needsReInit = true;
    this.e.innerHTML = getErrorHTML(this.opts.solutionFieldName, this.lang, "Background worker error " + e.message);
    this.makeButtonStart();
    this.opts.forceJSFallback = true;
  }
  initWorkerGroup() {
    this.workerGroup.progressCallback = (progress) => {
      updateProgressBar(this.e, progress);
    };
    this.workerGroup.readyCallback = () => {
      this.e.innerHTML = getReadyHTML(this.opts.solutionFieldName, this.lang);
      this.makeButtonStart();
      this.opts.readyCallback();
    };
    this.workerGroup.startedCallback = () => {
      this.e.innerHTML = getRunningHTML(this.opts.solutionFieldName, this.lang);
      this.opts.startedCallback();
    };
    this.workerGroup.doneCallback = (data) => {
      const solutionPayload = this.handleDone(data);
      this.opts.doneCallback(solutionPayload);
      const callback = this.e.dataset["callback"];
      if (callback) {
        window[callback](solutionPayload);
      }
    };
    this.workerGroup.errorCallback = (e) => {
      this.onWorkerError(e);
    };
    this.workerGroup.init();
    this.workerGroup.setupSolver(this.opts.forceJSFallback);
  }
  expire() {
    this.e.innerHTML = getExpiredHTML(this.opts.solutionFieldName, this.lang);
    this.makeButtonStart();
  }
  async start() {
    if (this.hasBeenDestroyed) {
      console.error("Can not start FriendlyCaptcha widget which has been destroyed");
      return;
    }
    this.hasBeenStarted = true;
    const sitekey = this.opts.sitekey || this.e.dataset["sitekey"];
    if (!sitekey) {
      console.error("FriendlyCaptcha: sitekey not set on frc-captcha element");
      this.e.innerHTML = getErrorHTML(this.opts.solutionFieldName, this.lang, "Website problem: sitekey not set", false);
      return;
    }
    if (isHeadless()) {
      this.e.innerHTML = getErrorHTML(this.opts.solutionFieldName, this.lang, "Browser check failed, try a different browser", false, true);
      return;
    }
    if (this.needsReInit) {
      this.needsReInit = false;
      this.init(true);
      return;
    }
    try {
      this.e.innerHTML = getFetchingHTML(this.opts.solutionFieldName, this.lang);
      this.puzzle = decodeBase64Puzzle(await getPuzzle(this.opts.puzzleEndpoint, sitekey, this.lang));
      setTimeout(() => this.expire(), this.puzzle.expiry - 3e4);
    } catch (e) {
      this.e.innerHTML = getErrorHTML(this.opts.solutionFieldName, this.lang, e.message);
      this.makeButtonStart();
      const code = "error_getting_puzzle";
      this.opts.errorCallback({ code, description: e.toString(), error: e });
      const callback = this.e.dataset["callback-error"];
      if (callback) {
        window[callback](this);
      }
      return;
    }
    this.workerGroup.start(this.puzzle);
  }
  handleDone(data) {
    this.valid = true;
    const puzzleSolutionMessage = `${this.puzzle.signature}.${this.puzzle.base64}.${encode(data.solution)}.${encode(data.diagnostics)}`;
    this.e.innerHTML = getDoneHTML(this.opts.solutionFieldName, this.lang, puzzleSolutionMessage, data);
    this.needsReInit = true;
    return puzzleSolutionMessage;
  }
  destroy() {
    this.workerGroup.terminateWorkers();
    this.needsReInit = false;
    this.hasBeenStarted = false;
    if (this.e) {
      this.e.remove();
      delete this.e;
    }
    this.hasBeenDestroyed = true;
  }
  reset() {
    if (this.hasBeenDestroyed) {
      console.error("FriendlyCaptcha widget has been destroyed, it can not be used anymore");
      return;
    }
    this.workerGroup.terminateWorkers();
    this.needsReInit = false;
    this.hasBeenStarted = false;
    this.init(this.opts.startMode === "auto" || this.e.dataset["start"] === "auto");
  }
}
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main = defineComponent({
  name: "VueFriendlyCaptcha",
  props: {
    sitekey: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    startMode: {
      type: String,
      default: "focus"
    },
    language: {
      type: String,
      default: "en"
    },
    solutionFieldName: {
      type: String,
      default: "frc-captcha-solution"
    },
    puzzleEndpoint: {
      type: String,
      default: "https://api.friendlycaptcha.com/api/v1/puzzle"
    }
  },
  emits: ["ready", "started", "done", "error"],
  setup(props, { emit }) {
    const captcha = ref();
    const widget = ref();
    const onReady = () => {
      emit("ready", widget);
    };
    const onStarted = () => {
      emit("started", widget);
    };
    const onDone = (solution) => {
      emit("done", solution);
    };
    const onError = (error) => {
      emit("error", error);
    };
    const init = () => {
      var _a;
      (_a = widget.value) == null ? void 0 : _a.init();
    };
    const start = () => {
      var _a;
      (_a = widget.value) == null ? void 0 : _a.start();
    };
    const reset = () => {
      var _a;
      (_a = widget.value) == null ? void 0 : _a.reset();
    };
    const destroy = () => {
      var _a;
      (_a = widget.value) == null ? void 0 : _a.destroy();
    };
    const isValid = () => {
      var _a;
      return ((_a = widget.value) == null ? void 0 : _a.valid) || false;
    };
    watch(captcha, () => {
      if (widget.value) {
        widget.value.reset();
      }
      if (!widget.value && captcha.value) {
        widget.value = new WidgetInstance(captcha.value, {
          sitekey: props.sitekey,
          startMode: props.startMode,
          language: props.language,
          solutionFieldName: props.solutionFieldName,
          puzzleEndpoint: props.puzzleEndpoint,
          readyCallback: onReady,
          startedCallback: onStarted,
          doneCallback: onDone,
          errorCallback: onError
        });
      }
    });
    return {
      captcha,
      widget,
      init,
      start,
      reset,
      destroy,
      isValid
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "captcha",
    class: normalizeClass(["vue-friendly-captcha frc-captcha", { dark: _ctx.dark }])
  }, null, 2);
}
var VueFriendlyCaptcha = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { VueFriendlyCaptcha as default };
